'use strict';

export { default as testGeoJson } from './worldbank-world.geo.json';
export { default as testGeoJson2 } from './escap.geo.json';
